import { FORM_ERROR } from "final-form";
import { useIntl } from "react-intl";
import useTrashablePromises from "hooks/useTrashablePromises";
import translateError from "utils/translateError";
import useGlobalContext from "hooks/globalData";
import {
  SaveResponse,
  IResourceLibraryItem,
  SaveResourceLibraryItemAttributeRequest,
} from "services/KnowfullyAdminClient";

import ResourceLibraryItemTopicForm from "./ResourceLibraryItemTopicForm";

type ResourceLibraryItemTopicCreateFormProps = {
  resourceLibraryItem: IResourceLibraryItem;
  onResourceLibraryItemTopicCreated: (
    createdResourceLibraryItemTopic: SaveResponse
  ) => void;
  onCancel: () => void;
};

const ResourceLibraryItemTopicCreateForm = ({
  onResourceLibraryItemTopicCreated,
  onCancel,
  resourceLibraryItem,
}: ResourceLibraryItemTopicCreateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { resourceLibraryService } = useGlobalContext();

  const onSubmit = (values: SaveResourceLibraryItemAttributeRequest) => {
    return registerPromise(
      resourceLibraryService.saveResourceLibraryItemTopicAttribute(
        resourceLibraryItem.id,
        values
      )
    )
      .then((createdTopic) => {
        onResourceLibraryItemTopicCreated(createdTopic);
      })
      .catch((err: any) => {
        return { [FORM_ERROR]: translateError(err, t) };
      });
  };

  return (
    <ResourceLibraryItemTopicForm
      resourceLibraryItem={resourceLibraryItem}
      onSubmit={onSubmit}
      submitLabel={t({ id: "resourceLibraryFormCreateItemAttributeButton" })}
      onCancel={onCancel}
    />
  );
};

export default ResourceLibraryItemTopicCreateForm;
